import {
    emailRegex,
    mobileRegex,
    landlineRegex,
    lettersPuncNums,
    lettersOnly,
    eircodeRegex,
    passwordRegex,
    lettersNumbersExclusive
} from '../components/Variables';

export const ValidationRules = {
    isPhoneOrMobile: (e, m = "Must must enter a valid phone number") => {
        return { result: (landlineRegex.test(e) || mobileRegex.test(e)), message: m }
    },
    required: (e, m = "This field is required") => {
        return { result: (e != null && e != ""), message: m};
    },
    containLowerCase: (e, m = "Must contain at least one lowercase letter") => {
        return { result: /^(?=.*[a-z])/.test(e), message: m }
    },
    containUpperCase: (e, m = "Must contain at least one uppercase letter") => {
        return { result: /^(?=.*[A-Z])/.test(e), message: m }
    },
    containNumber: (e, m = "Must contain at least one number") => {
        return { result: /^(?=.*[0-9])/.test(e), message: m }
    },
    validEircode: (e, m = "Not valid a valid eircode") => {
        return { result: validEircode(e), message: m }
    },
    AplhaNumberic: (e, m = "Please enter letters & numbers only ") => {
        return { result: /^[0-9a-zA-Z]+$/.test(e), message: m }
    },
    LettersOnly: (e, m = "Must be letters only") => {
        return { result: LettersOnly(e), message: m }
    },
    lettersNumbersExclusive: (e, m = "Must be letters numbers and spaces only") => {
        return { result: lettersNumbersExclusive.test(e), message: m }
    },
    AlphaNumPunc: (e, m = "Can only contain letters, numbers and basic punctuation") => {
        return { result: AlphaNumPunc(e), message: m }
    },
    isValidPhoneNumber: (e, m = "Please enter a valid landline number") => {
        return { result: isValidPhoneNumber(e), message: m }
    },
    isValidMobile: (e, m = "Please enter a valid mobile number") => {
        return { result: isValidMobile(e), message: m }
    },
    isValidEmail: (e, m = "Please enter a valid email address") => {
        return { result: emailRegex.test(e), message: m }
    },
    repeatingChars: (e, m = "Cannot repeat characters more than twice in a row") => {
        return { result: !/([a-zA-Z0-9])\1{2}/.test(e), message: m }
    },
    pattern: (e, regex, m = "Input not valid") => {
        return { result: regex.test(e), message: m }
    },
    minLength: (e, l = 8, m = "Must be at least " + l + " characters Long") => {        
        return {result: (e.length >= l), message: m}
    },
    minValue: (e, min = 0, m = "You must enter a value greater than or equal to " + min) => {
        return { result: (e >= min), message: m }
    },
    custom: (e, bool, m = "This field is not valid") => {
        return { result: bool, message: m };
    },
};

export const validEircode = (string) => {
    return eircodeRegex.test(string);
};

export const LettersOnly = (string) => {
    return lettersOnly.test(string);
};

export const AlphaNumPunc = (string) => {
    return lettersPuncNums.test(string);
};

export const isValidPassword = (string) => {
    return passwordRegex.test(string);
}

export const isValidPhoneNumber = (number) => {
    return landlineRegex.test(number);
};

export const isValidMobile = (mobile) => {
    return mobileRegex.test(mobile);
};

export const isValidEmail = (email) => {
    return emailRegex.test(email);
};

export const hasClass = (elem, className) => {
    return new RegExp(' ' + className + ' ').test(' ' + elem.className + ' ');
};

export const validateEmail = (string) => {
    var messageVal = "This field is required";
    var hasErrorVal = true;

    if ((string == "" || string == null)) {
        messageVal = "This field is required";
        hasErrorVal = true;
    } else {
        if (!isValidEmail(string)) {
            messageVal = "You must enter a valid email";
            hasErrorVal = true;
        } else {
            messageVal = "";
            hasErrorVal = false;
        }
    }
    return { message: messageVal, hasError: hasErrorVal };
}

export const validateMobile = (string) => {
    var messageVal = "This field is required";
    var hasErrorVal = true;

    if ((string == "" || string == null)) {
        messageVal = "This field is required";
        hasErrorVal = true;
    } else {
        if (!isValidMobile(string)) {
            messageVal = "You must enter a valid Mobile";
            hasErrorVal = true;
        } else {
            messageVal = "";
            hasErrorVal = false;
        }
    }
    return { mobileMessage: messageVal, mobileError: hasErrorVal };
}

export const validateWorkNumber = (string) => {
    var messageVal = "This field is required";
    var hasErrorVal = true;

    if ((string == "" || string == null)) {
        messageVal = "This field is required";
        hasErrorVal = true;
    } else {
        if (!isValidPhoneNumber(string)) {
            messageVal = "You must enter a valid Work Number";
            hasErrorVal = true;
        } else {
            messageVal = "";
            hasErrorVal = false;
        }
    }
    return { workMessage: messageVal, workError: hasErrorVal };
}

export const address1 = (string) => {
    var messageVal = "This field is required";
    var hasErrorVal = true;
    if ((string == "" || string == null)) {
        messageVal = "This field is required";
        hasErrorVal = true;
    } else {
        if (!AlphaNumPunc(string)) {
            messageVal = "You must enter valid characters only";
            hasErrorVal = true;
        } else {
            messageVal = "";
            hasErrorVal = false;
        }
    }
    return { line1Message: messageVal, line1Error: hasErrorVal };
}

export const address2 = (string) => {
    var messageVal = "This field is required";
    var hasErrorVal = true;

    if ((string == "" || string == null)) {
        messageVal = null;
        hasErrorVal = false;
    } else {
        if (!AlphaNumPunc(string)) {
            messageVal = "You must enter valid characters only";
            hasErrorVal = true;
        } else {
            messageVal = "";
            hasErrorVal = false;
        }
    }
    return { line2Message: messageVal, line2Error: hasErrorVal };
}

export const address3 = (string) => {
    var messageVal = "This field is required";
    var hasErrorVal = true;

    if ((string == "" || string == null)) {
        messageVal = null;
        hasErrorVal = false;
    } else {
        if (!AlphaNumPunc(string)) {
            messageVal = "You must enter valid characters only";
            hasErrorVal = true;
        } else {
            messageVal = "";
            hasErrorVal = false;
        }
    }
    return { line3Message: messageVal, line3Error: hasErrorVal };
}

export const town = (string) => {
    var messageVal = "This field is required";
    var hasErrorVal = true;

    if ((string == "" || string == null)) {
        messageVal = "This field is required";
        hasErrorVal = true;
    } else {
        if (!AlphaNumPunc(string)) {
            messageVal = "You must enter valid characters only";
            hasErrorVal = true;
        } else {
            messageVal = "";
            hasErrorVal = false;
        }
    }
    return { townMessage: messageVal, townError: hasErrorVal };
}

export const county = (string) => {
    var messageVal = "This field is required";
    var hasErrorVal = true;

    if ((string == "" || string == null)) {
        messageVal = "This field is required";
        hasErrorVal = true;
    } else {
        if (!LettersOnly(string)) {
            messageVal = "You must enter valid characters only";
            hasErrorVal = true;
        } else {
            messageVal = "";
            hasErrorVal = false;
        }
    }
    return { countyMessage: messageVal, countyError: hasErrorVal };
}

export const eircode = (string) => {
    var messageVal = "This field is required";
    var hasErrorVal = true;

    if ((string == "" || string == null)) {
        messageVal = null;
        hasErrorVal = false;
    } else {
        if (!validEircode(string)) {
            messageVal = "You must be valid Eircode format";
            hasErrorVal = true;
        } else {
            messageVal = "";
            hasErrorVal = false;
        }
    }
    return { eircodeMessage: messageVal, eircodeError: hasErrorVal };
}


// WEBPACK FOOTER //
// ./src/Functions/Validation.js